module.exports = __webpack_public_path__ + "img/coloured.851a5e08.png";